<ui-title [title]="'Help'"></ui-title>

<p>
	If you need training or help please check the <a
	href="https://hccins.sharepoint.com/:f:/r/sites/tmhcci-IT/Documents/QARSOD?csf=1&web=1&e=oVzSWB">documentation</a>
	or send an email to qarsod_admin@tmhcc.com
</p>
